import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import store from './store/index';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.prototype.myWindow = window;
document.title = process.env.VUE_APP_TITLE;

// axios global configuraiton
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
axios.defaults.headers.common['x-functions-key'] = process.env.VUE_APP_AZURE_FUNCTION_KEY;

Vue.use(store);

new Vue({
  vuetify,
  render(h) {
    return h(App);
  },
  store,
}).$mount('#app');
